<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <div class="col-12" style="padding: 0px 10px">
        <h4>{{ this.$t('reports.cxiReport.reportHeader1') }}</h4>
        {{ this.$t('reports.cxiReport.reportHeader2') }}
      </div>
      <div v-if="this.myIh1 !== '0'" class="row px-3 board-header">
        <div class="col-12" style="padding: 0px 10px">
          <span>Nacional:</span>
          <span class="idx-bold">
            {{ nationalData }}
          </span>
          <span>Regional - {{ groupName }}: </span>
          <span class="idx-bold">
            {{ groupData }}
          </span>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4" style="padding: 0px 10px">
          <div class="col-12 board-border">
            <div class="col-12" style="display: flex">
              <div style="min-width: 100%">
                <div class="nps-display">
                  <div class="idx-card-title">
                    {{ this.$t('reports.cxiReport.reportTitle') }}
                  </div>
                  <div class="nps-chart">
                    <radial-progress-bar
                      v-if="cxiScore !== null && cxiScore !== undefined"
                      :diameter="240"
                      :stroke-width="20"
                      innerStrokeColor="#f1f1f1"
                      :startColor="colorBalance"
                      :stopColor="colorBalance"
                      :completed-steps="
                        completedSteps ? parseFloat(completedSteps) : 0
                      "
                      :total-steps="totalSteps"
                    >
                      <b
                        id="number-cxi"
                        :style="{
                          color: colorBalance,
                          fontSize: '2.8em',
                          fontWeight: 'bold',
                        }"
                        >{{ completedSteps }}</b
                      >
                      <b-tooltip
                        v-if="cxiScore !== null && cxiScore !== undefined"
                        target="number-cxi"
                        placement="bottom"
                      >
                        {{ this.$t('reports.cxiReport.cxiLabel') }}
                        <strong>{{ cxiScore }}</strong>
                      </b-tooltip>
                    </radial-progress-bar>
                    <div v-else>
                      {{ this.$t('reports.cxiReport.noDataMsg') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8" style="padding: 0px 10px">
          <div class="col-12 board-border" style="padding: 0px 10px">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
        <div class="col-12" style="padding: 0px 10px">
          <div class="col-12 board-border" style="padding: 0px 10px">
            <b-table
              :fields="fields"
              :items="items"
              caption-bottom
              sort-icon-left
            >
              <template v-slot:cell(question)="row">
                <div style="max-width: 85%">
                  {{ row.item.question }}
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <hr />
      <div v-if="this.userAuth.companyId !== '5eea25739b8df13f10e8da40'">
        <div class="row mt-5 header">
          <div class="col-12">
            <h4>{{ $t('reports.cxiReport.satisfaction') }}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="chart-card">
              <h2>{{ $t('reports.cxiReport.index') }}</h2>
              <div class="chart-area">
                <radial-progress-bar
                  :diameter="240"
                  :stroke-width="20"
                  innerStrokeColor="#f1f1f1"
                  :startColor="satisfaction.color"
                  :stopColor="satisfaction.color"
                  :completed-steps="satisfaction.score"
                  :total-steps="5"
                >
                  <b
                    :style="{
                      color: satisfaction.color,
                      fontSize: '2.8em',
                      fontWeight: 'bold',
                    }"
                    >{{ satisfaction.score }}</b
                  >
                </radial-progress-bar>
              </div>
            </div>
          </div>
          <div class="col-8">
            <div class="chart-card">
              <h2>{{ $t('reports.cxiReport.indexByMonth') }}</h2>
              <div class="chart-area">
                <div class="col-12" style="max-width: 100%">
                  <highcharts :options="satisfaction.chartOptions"></highcharts>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <b-table
              :fields="fields"
              :items="satisfaction.items"
              caption-bottom
              sort-icon-left
            >
              <template v-slot:cell(question)="row">
                <div style="max-width: 85%">
                  {{ row.item.question }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';

export default {
  name: 'CxiReport',
  components: {
    RadialProgressBar,
    animatedNumber,
    loader,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    chartOptions: {},
    cxi: {},
    cxiScore: 0,
    completedSteps: null,
    totalSteps: 100,
    colorBalance: '#fff',
    fields: [],
    items: [],
    nationalData: null,
    groupData: null,
    groupname: null,
    satisfaction: {
      score: 0,
      items: [],
      color: '#4ce595',
      chartOptions: {
        title: {
          align: 'left',
          text: '',
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
            fontSize: '12px',
            width: '100%',
            height: '350px',
          },
        },
        xAxis: {
          categories: [],
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 5,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: 'Score',
            data: [],
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      },
    },
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getCxiData();
    },

    myActionId: function watchmyActionId() {
      this.getCxiData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getCxiData();
    },

    calendarDates: function watchCalendarDates() {
      this.getCxiData();
    },

    myIh1: function watchMyIh1() {
      this.getCxiData();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getCxiData();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getCxiData();
    },

    myIh2: function watchMyIh2() {
      this.getCxiData();
    },

    myMetric: function watchMyMetric() {
      this.getCxiData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getCxiData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getCxiData();
    },
  },

  methods: {
    async renderChart(data) {
      this.chartOptions = {
        title: {
          align: 'left',
          text: this.$t('reports.cxiReport.cxiLabel'),
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: data.categories,
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 100,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: this.$t('reports.cxiReport.cxiLabel'),
            data: data.series,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      };
    },

    async chartEmpty() {
      if (this.cxi.categories.length === 0) {
        this.chartOptions = {
          title: {
            align: 'left',
            text: this.$t('reports.cxiReport.reportTitle'),
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.type,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
        };
      }
    },

    async getCxiData() {
      this.loading = true;

      let response = null;

      const headers = {
        'x-access-token': this.userAuth.token,
      };
      const params = {
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        startDate: this.calendarDates.start,
        endDate: this.calendarDates.end,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      };

      if (this.userAuth.companyId === '5eea25739b8df13f10e8da40') {
        // Daimler Latina
        response = await api.get('/reports/cxi-latina', {
          headers: { ...headers },
          params: {
            ...params,
            reportType: 'after-sale',
          },
        });

        if (response) {
          this.cxi.categories = response.data.categories;
          this.cxi.series = response.data.series;
          this.cxiScore = response.data.score;
          this.completedSteps = this.cxiScore;
          this.items[0].score = response.data.satScore;
          this.items[1].score = response.data.recScore;
          this.items[2].score = response.data.revScore;
          this.items[0].qty = response.data.nSat;
          this.items[1].qty = response.data.nRec;
          this.items[2].qty = response.data.nRev;
          this.setColorCxi(this.completedSteps);
          this.renderChart({
            categories: this.cxi.categories,
            series: this.cxi.series,
          });
          this.nationalData = response.data.cxiNacional;
          this.groupData = response.data.cxiRegional;
          this.groupname = response.data.regionalName;
        }
      } else {
        response = await api.get('/reports/cxi', {
          headers: { ...headers },
          params: { ...params },
        });

        if (response) {
          this.cxi.categories = response.data.categories;
          this.cxi.series = response.data.series;
          this.cxiScore = response.data.score;
          this.completedSteps = this.cxiScore;
          this.items[0].score = response.data.satScore;
          this.items[1].score = response.data.recScore;
          this.items[2].score = response.data.revScore;

          this.items[0].qty = response.data.nSat;
          this.items[1].qty = response.data.nRec;
          this.items[2].qty = response.data.nRev;

          this.setColorCxi(this.completedSteps);
          this.renderChart({
            categories: this.cxi.categories,
            series: this.cxi.series,
          });
          this.nationalData = response.data.cxiNacional;
          this.groupData = response.data.cxiRegional;
          this.groupname = response.data.regionalName;

          this.satisfaction.chartOptions.xAxis.categories = [];
          this.satisfaction.chartOptions.series[0].data = [];
          this.satisfaction.score = Number(
            response.data.chartsData.satisfaction.score,
          );
          response.data.chartsData.satisfaction.months.forEach((el) => {
            this.satisfaction.chartOptions.xAxis.categories.push(el.month);
            this.satisfaction.chartOptions.series[0].data.push(
              Number(el.score),
            );
          });
        }

        this.satisfaction.items =
          response.data.chartsData.satisfaction.questions;
        this.satisfaction.color = this.setColor(
          response.data.chartsData.satisfaction.score,
        );
      }

      this.loading = false;
    },

    setColor(score) {
      if (score >= 4) {
        return '#6bca6c';
      } else if (score < 4 && score >= 3) {
        return '#9fd77a';
      } else if (score < 3 && score >= 2) {
        return '#fbcf3f';
      } else if (score < 2 && score >= 1) {
        return '#fa834f';
      }
      return 'red';
    },

    setColorCxi(percentBalace) {
      if (percentBalace >= 80) {
        this.colorBalance = '#6bca6c';
      } else if (percentBalace < 80 && percentBalace >= 70) {
        this.colorBalance = '#9fd77a';
      } else if (percentBalace < 70 && percentBalace >= 50) {
        this.colorBalance = '#fbcf3f';
      } else if (percentBalace < 50 && percentBalace >= 20) {
        this.colorBalance = '#fa834f';
      } else if (percentBalace < 20) {
        this.colorBalance = 'red';
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.cxiReport.questionHeader'),
        sortable: true,
        class: 'questionTh',
      },
      {
        key: 'score',
        label: this.$t('reports.cxiReport.score'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'qty',
        label: 'Total',
        sortable: true,
        class: 'text-center',
      },
    ];
    if (this.userAuth.companyId === '5eea25739b8df13f10e8da40') {
      // Daimler Latina
      this.items = [
        {
          question:
            '¿Qué tan satisfecho está con el sector de servicios del concesionario?',
          score: 0,
          qty: 0,
        },
        {
          question:
            'En una escala de 0 a 10, cuanto usted recomendaría a este taller de reparos para un amigo o familiar?',
          score: 0,
          qty: 0,
        },
        {
          question:
            '¿Qué probabilidad habría de que usted lleve su vehículo a este taller de reparos nuevamente?',
          score: 0,
          qty: 0,
        },
      ];
    } else {
      this.items = [
        {
          question:
            'Como você avalia sua experiência geral desde o 1º contato até o momento em que retirou o seu veículo da oficina?',
          score: 0,
          qty: 0,
        },
        {
          question:
            'Em uma escala de 0 a 10, quanto você recomendaria a oficina da Mercedes-Benz a um amigo ou empresa?',
          score: 0,
          qty: 0,
        },
        {
          question:
            'Qual a possibilidade de voltar a utilizar os serviços desta concessionária?',
          score: 0,
          qty: 0,
        },
      ];
    }
  },

  async mounted() {
    this.loading = true;
    await this.getCxiData();
    this.loading = false;
  },
};
</script>

<style lang="scss">
#number-cxi {
  font-size: 50px !important;
}
.scoreTh {
  width: 70px;
  padding-right: 0px !important;
}

.questionTh {
  width: calc(100% - 200px);
}
</style>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.chart-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e1e1;
  padding: 16px;
  border-radius: 5px;
  height: 400px;

  h2 {
    font-size: 18px;
  }

  .chart-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.board-box {
  width: 10%;
  text-align: left;
  font-size: 16px;
  margin: 0px 20px;
  border: 1px solid #eee;
}
.board-box-value {
  float: right;
  padding-right: 40%;
  font-size: 24px;
}
.nps-display {
  border: none !important;
}
.board-percentil {
  padding: 20px 0px 20px 20px;
  min-width: 150px;
}
.board-percentil-label {
  font-size: 14px;
}
.board-percentil-percent {
  font-size: 20px;
}
.board-percentil-value {
  font-size: 16px;
}
.board-border {
  border: 1px solid #eee;
}
.board-header h1 {
  font-size: 16px;
}
.radial-progress-inner {
  justify-content: center;
  font-size: 3.2em;
  cursor: pointer;
}
.nps-display {
  border: 1px solid $gray-light;
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }
  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/cxi-report/index.vue